import React, {useState, useEffect} from 'react';
import CollapseButton from '../../../utilities/CollapseButton/CollapseButton';
import {transactionType, actionDescription} from '../../Page/TransactionSummaryPage/Shared/Constants';
import TradeInInfoEquipment from './TradeInInfoEquipment';
import {
  setPriceCyclesDescription,
  constructPurchasedPrice,
  checkSectionValid,
  checkRegularPayment,
  setStatusStyle,
} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';

const EquipmentSummary = ({data, context, equipmentSummary, dealType, currentSubscriber}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [allEquipments, setEquipments] = useState(<div />);
  const [showComponent, setShowComponent] = useState(checkSectionValid(equipmentSummary));
console.log("equipmentSummary: "+JSON.stringify(equipmentSummary));
  useEffect(() => {
    if (showComponent || currentSubscriber !== undefined) {
      if (currentSubscriber === undefined || dealType === transactionType.CancelDeal) {
        setEquipments(setDetails(equipmentSummary, dealType));
      } else {

        // Clone the equipmentSummary object to avoid modifying the original
        const clonedEquipmentSummary = { ...equipmentSummary };

        var equipmentBySubscriber = {};
        equipmentBySubscriber.loanedEquipment = equipmentSummary?.loanedEquipment?.filter(
          (loaned) => loaned.subscriber === currentSubscriber,
        );
        equipmentBySubscriber.purchasedEquipment = equipmentSummary?.purchasedEquipment?.filter(
          (purchased) => purchased.subscriber === currentSubscriber,
        );
        equipmentBySubscriber.tradeInInfoEquipment = equipmentSummary?.tradeInInfoEquipment?.filter(
          (tradeIn) => tradeIn.subscriber === currentSubscriber,
        );
        setShowComponent(true);
        setEquipments(setDetails(clonedEquipmentSummary, dealType));
        if (
          equipmentBySubscriber?.loanedEquipment.length === 0 &&
          equipmentSummary?.purchasedEquipment.length === 0 &&
          equipmentSummary?.tradeInInfoEquipment.length === 0
        ) {
          setShowComponent(false);
        }
      }
    }
  }, [equipmentSummary, currentSubscriber]);

  let cardTitle =
    data?.equipmentSummaryTopic?.value === '' || equipmentSummary?.tradeInInfoEquipment?.length > 0 ? 'ציוד' : data?.equipmentSummaryTopic?.value;
console.log("cardTitle: "+cardTitle);
  if (dealType === transactionType.CancelDeal) {
    cardTitle = 'מוצרים והשירותים שבחרת לבטל';
  }

  return showComponent ? (
    <div className='block-frame mb-2'>
      <CollapseButton cardTitle={cardTitle} setIsOpen={setIsOpen} isOpen={isOpen} />
      {isOpen && (
        <div className='block-frame__container'>
          <div className='equipment-summary'>{allEquipments}</div>
        </div>
      )}
    </div>
  ) : null;
};

function setDetails(equipmentSummary, dealType) {
  const isDealTypeChangeOrReplace = dealType === transactionType.Replace || dealType === transactionType.Change;

  const loanedEquipment = equipmentSummary?.loanedEquipment.map((equipment, idx) => {
    const isCancelled = equipment.action.toLowerCase() === 'remove' || equipment.action.toLowerCase() === 'disconnect';
    let rowStyle = 'block-frame__row' + (isDealTypeChangeOrReplace ? ' with-status-layout' : '');

    if (!checkRegularPayment(equipment.priceCycles)) {
      rowStyle += ' block-frame__row--1';
    }

    return (
      <div className='block-frame__list-info' key={idx.toString() + equipment.name}>
        <div className={rowStyle}>
          <div className='block-frame__status-holder'>
            {isDealTypeChangeOrReplace && (
              <p className={'block-frame__status block-frame__status' + setStatusStyle(equipment.action)}>
                {actionDescription[equipment.action]}
              </p>
            )}
            <div>
              <label className={isCancelled ? 'cancelled' : ''}>{equipment.name}</label>
              {equipment.productCode === 'SBEQU' && <label className={'block-frame__amount-unit'}>{equipment.amount} יחידות</label>}
            </div>
          </div>
          {setPriceCyclesDescription(equipment.priceCycles, '', isCancelled, dealType)}
        </div>
      </div>
    );
  });

  const tradeInInfoEquipment = equipmentSummary?.tradeInInfoEquipment;
  const purchasedEquipment = equipmentSummary?.purchasedEquipment.map((equipment) => {
  return (
    <div className='block-frame__list-info' key={equipment.orderLineId}>
      <div className='block-frame__row block-frame__row--2'>
        <p className={'block-frame__status block-frame__status' + setStatusStyle(equipment.action)}>
          {actionDescription[equipment.action]}
        </p>
        <label>{equipment.name}</label>
        {constructPurchasedPrice(equipment.price, equipment.numOfInstallments, equipment.nextPaymentAmount, dealType,equipment.effectiveInterest,equipment.cashPrice)}
      </div>
      {equipment.campaignDesc &&
          <>
            <p style={{'margin': '0 4px 0 0'}}
               className={'block-frame__status block-frame__status--2'}>
              מבצע
            </p>
            <label>{equipment.campaignDesc}</label>
          </>

      }
    </div>
  );
});



  const hasLoanedEquipment = loanedEquipment.length > 0 && loanedEquipment[0] !== undefined;
  const hasPurchasedEquipment = purchasedEquipment.length > 0 && purchasedEquipment[0] !== undefined;
  const hasTradeInEquipment = tradeInInfoEquipment?.length > 0 && tradeInInfoEquipment[0] !== undefined;

  return (
    <React.Fragment>
      {hasLoanedEquipment && dealType !== transactionType.Accessory && (
        <div>
          <label className='block-frame__sub-title'>ציוד בהשכרה</label>
          <hr />
          {loanedEquipment}
        </div>
      )}
      {hasPurchasedEquipment && (
        <div>
          {dealType !== transactionType.Accessory && (
            <label
              className={hasLoanedEquipment && hasPurchasedEquipment ? 'block-frame__sub-title add-margin-top' : 'block-frame__sub-title'}>
              {dealType === transactionType.CancelDeal ? '' : 'ציוד במכירה'}
            </label>
          )}
          <hr />
          {purchasedEquipment}
        </div>
      )}
      {hasTradeInEquipment && (
        <div className='mt-5'>
          <label className='block-frame__sub-title'>ציוד בטרייד-אין</label>
          <hr />
          <div className='table'>
            <TradeInInfoEquipment tradeInInfoEquipment={tradeInInfoEquipment} />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default EquipmentSummary;
